<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-07-27 15:10:09
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-09-20 11:43:08
 * @FilePath: \ces-vue-serve\src\views\Finance\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <rj-tabs v-model="tabsActive">
    <rj-tab-pane name="1">
      <span slot="label">国内/国际电汇查询</span>
      <FinanceremittanceList />
    </rj-tab-pane>
    <rj-tab-pane v-if="!perssimionCodeList.includes('businessWireTransferList')" name="2">
      <span slot="label">国际电汇查询</span>
      <InternationalList />
    </rj-tab-pane>
    <rj-tab-pane name="4">
      <span slot="label">退款查询</span>
      <refund />
    </rj-tab-pane>
    <rj-tab-pane v-if="!perssimionCodeList.includes('businessWireTransferList')" name="3">
      <span slot="label">修改客户审核</span>
      <ModifyCustomerApproval />
    </rj-tab-pane>
  </rj-tabs>
</template>
<script type="es6">
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import FinanceremittanceList from './components/FinanceremittanceList';
import InternationalList from './components/InternationalList';
import ModifyCustomerApproval from './components/ModifyCustomerApproval';
import refund from './components/refund/index.vue';
import { mapState } from 'vuex';
export default {
  data () {
    return {
      nums: {
        submit: 0
      }
    };
  },
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    FinanceremittanceList,
    InternationalList,
    ModifyCustomerApproval,
    refund
  },
  computed: {
    tabsActive: {
      get () {
        return this.$store.state.pagesTemporary.FinanceListTabActive;
      },
      set (val) {
        this.$store.commit('pagesTemporary/SETFinanceListTabActive', val);
      }
    },
    ...mapState({
      perssimionCodeList: state => state.user.perssimionCodeList // 登录权限

    })
  },
  methods: {
  },
  mounted () {

  }
};
</script>
